import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import moment from "moment";
import parse from "html-react-parser"
import Countdown, {
    zeroPad,
    calcTimeDelta,
    formatTimeDelta,
} from "react-countdown";

import Loader from "../Loader";
import { userAvatarUrl, questionImageUrl } from "../../utils/assets";

import { getYearQuestions } from "./../../actions/questionActions";
import { Editor } from "@tinymce/tinymce-react";

import { submitExamResult } from "./../../actions/resultActions";
import { SUBMIT_RESULT_RESET } from "./../../constants/resultConstants";

import "./question.css";
import Modal from "../Modal/Modal";
import Calculator from "../Calculator/Calculator";

const TheoriesQuestions = ({ history }) => {
    const alert = useAlert();
    const dispatch = useDispatch();

    const { user, loading, error } = useSelector((state) => state.auth);

    const userId = user?._id;

    const examId = localStorage.getItem("examId");
    const examType = localStorage.getItem("examType");
    const subjectId = localStorage.getItem("subjectId");
    const subjectIds = localStorage.getItem("checkedSubjects")?.split(",");
    const year = localStorage.getItem("year");
    const shuffleQuestions = localStorage.getItem("shuffleQuestions");
    const shuffleOptions = localStorage.getItem("shuffleOptions");
    const timeDuration = localStorage.getItem("timeDuration");
    // alert.info(timeDuration);
    //var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
    const assessmentId = localStorage.getItem("assessmentId");
    const assessmentType = localStorage.getItem("assessmentName");
    const savedSubjectId = localStorage.getItem("savedId");
    const subscriptionId = localStorage.getItem("userSubscription");
    const questionLimit = localStorage.getItem("questionLimit") || localStorage.getItem("questionCount");
    
    // Redirect to login if user is not authenticated
    useEffect(() => {
        if (!loading && !user) {
            history.push('/login');
        }
    }, [user, loading, history]);

    function disableF5(e) {
        if ((e.which || e.keyCode) == 116 || (e.ctrlKey && e.keycode == 82)) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    useEffect(() => {
        window.addEventListener("keydown", disableF5);

        window.history.pushState(null, document.title, window.location.href);
        window.history.back();
        window.history.forward();
        window.onpopstate = function () {
            history.go(1);
        };
        
        // Use questionLimit with proper fallback
        const limit = Number(questionLimit) || 50; // Default to 50 if not set
        
        console.log('🔍 [TheoriesQuestions] Fetching questions with limit:', limit);
        console.log('  📋 questionLimit from localStorage:', questionLimit);
        
        dispatch(
            getYearQuestions(
                examId,
                examType,
                subjectIds,
                year,
                shuffleQuestions,
                shuffleOptions,
                [],
                limit,
                [],
                subscriptionId,
                userId || null
            )
        );
    }, [dispatch, alert]);

    const { examData, questions, questionCount, qLoading } = useSelector(
        (state) => state.yearQuestions
    );

    const [showCalculator, setShowCalculator] = useState(false);

    // console.log("questions ", questions); return
    const [totalQuestions, setTotalQuestions] = useState(0);

    const [currentSubject, setCurrentSubject] = useState(0);

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);

    const [unanswered, setUnanswered] = useState([]);
    const [answered, setAnswered] = useState([]);
    const [markForReviewed, setMarkForReviewed] = useState([]);

    const [detailedAns, setDetailedAns] = useState("");

    const [theoriesAnswered, setTheoriesAnswered] = useState([]);

    const [showResults, setShowResults] = useState(false);
    const [rightAnswer, setRightAnswer] = useState("");
    const [description, setDescription] = useState("123")

    const [totalTime, setTotalTime] = useState(
        Date.now() + parseInt(timeDuration) * 60 * 1000
    );
    const [quizTotalTime, setQuizTotalTime] = useState("");
    const [remainingTime, setRemainingTime] = useState("");
    const [takenTime, setTakenTime] = useState("");

    useEffect(() => {
        if (
            questions !== undefined &&
            questions.length > 0 &&
            questions[0].theories !== undefined &&
            questions[0].theories.length > 0
        ) {
            // var timerData = Date.now() + parseInt(timeDuration) * 60 * 1000;
            // setTotalTime(timerData);

            setTotalQuestions(questionCount);
            setNumberOfQuestions(questions[0].theories.length);
            // alert.success(numberOfQuestions);
        }
    }, [questions, rightAnswer]);

    const [selections, setSelections] = useState([
        Object.keys(questions).map((x) => []),
    ]);

    const activeSubject = questions?.[currentSubject];
    const activeTheory = activeSubject?.theories?.[currentQuestion] || null;
    const activeTheoryId = activeTheory?._id;

    const normalizeLabel = (value) =>
        value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "";
    const assessmentLabel = normalizeLabel(assessmentType);
    const examTypeLabel = normalizeLabel(examType);
    const normalizeText = (value) =>
        typeof value === "string" ? value.replace(/<[^>]*>/g, "").trim() : "";
    const normalizedTitle = normalizeText(activeTheory?.title);
    const normalizedQuestion = normalizeText(activeTheory?.question);
    const shouldShowSubtitle = Boolean(
        normalizedTitle &&
        (!normalizedQuestion || normalizedTitle !== normalizedQuestion)
    );
    const shouldShowQuestionText = Boolean(normalizedQuestion);
    const currentTheoryAnswerValue = activeTheoryId
        ? theoriesAnswered.find((item) => item.theory === activeTheoryId)?.answer || ""
        : "";
    const userFirst = user?.first_name || "";
    const userLast = user?.last_name || "";

    const handleSubjectType = (e) => {
        e.preventDefault();
        const currentIndex = parseInt(e.target.dataset.id);

        setCurrentSubject(currentIndex);
        setCurrentQuestion(0);
        // alert.success(currentIndex);
        if (
            questions !== undefined &&
            questions.length > 0 &&
            questions[currentIndex].theories !== undefined &&
            questions[currentIndex].theories.length > 0
        ) {
            // alert.success(questions[currentIndex].questions.length);
            setNumberOfQuestions(questions[currentIndex].theories.length);
        }
        setShowResults(false);
    };


    const handleTheoriesAnswer = (event) => {
        const answerData = event.target.value;
        const selectedTheoriesId = event.target.dataset.theoriesid;

        let tAnsweredArray = [
            ...theoriesAnswered,
            {
                theory: selectedTheoriesId,
                answer: event.target.value,
            },
        ];
        //remove duplicate question
        if (theoriesAnswered.some((ques) => ques.theory === selectedTheoriesId)) {
            tAnsweredArray = tAnsweredArray.filter((qItem) => {
                return (
                    qItem.theory !== selectedTheoriesId
                    // qItem.answer !== event.target.value
                );
            });
            tAnsweredArray = [
                ...tAnsweredArray,
                {
                    theory: selectedTheoriesId,
                    answer: event.target.value,
                },
            ];
        }
        // setAnswered(answeredArray);

        setTheoriesAnswered(tAnsweredArray);
    };

    const handleTheoriesEditorAnswer = (id, value) => {
        const selectedTheoriesId = id;


        let tAnsweredArray = [
            ...theoriesAnswered,
            {
                theory: selectedTheoriesId,
                answer: value,
            },
        ];
        //remove duplicate question
        if (theoriesAnswered.some((ques) => ques.theory === selectedTheoriesId)) {
            tAnsweredArray = tAnsweredArray.filter((qItem) => {
                return (
                    qItem.theory !== selectedTheoriesId
                    // qItem.answer !== value
                );
            });
            tAnsweredArray = [
                ...tAnsweredArray,
                {
                    theory: selectedTheoriesId,
                    answer: value,
                },
            ];
        }
        // setAnswered(answeredArray);
        setTheoriesAnswered(tAnsweredArray);
    };


    const handleNextQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) + 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);
    };
    // console.log(currentQuestion, numberOfQuestions);
    const handlePreviousQuestionClick = (e) => {
        e.preventDefault();
        const nextQuestion = parseInt(currentQuestion) - 1;
        setCurrentQuestion(nextQuestion);
        setShowResults(false);
    };

    const handleViewAnswer = (e) => {
        //alert.success(numberOfQuestions);
        e.preventDefault();
        if (activeTheory) {
            setRightAnswer(activeTheory.answer);
            setDescription(activeTheory?.description);
            setDetailedAns(activeTheory?.detailedAnswer);
        }
        setShowResults(!showResults);
        // alert.success(rightAnswer);
    };

    const handleFilterQuestion = (e) => {
        e.preventDefault();
        const currentQue = e.target.dataset.id;
        // alert.info(currentQue);
        setCurrentQuestion(currentQue);
        setShowResults(false);
    };

    const handleMarkForReview = (event) => {
        let reviewArray = [...markForReviewed, event.target.value];
        if (markForReviewed.includes(event.target.value)) {
            reviewArray = reviewArray.filter((it) => it !== event.target.value);
        }
        setMarkForReviewed(reviewArray);
        // if (event.target.checked === true) {
        //   setDisabled(false);
        // }
        //alert.success("markForReviewed ", markForReviewed);
    };

    const handleRemainigTime = (data) => {
        // totalTime
        var quizHour = Math.floor(timeDuration / 60);
        quizHour = parseInt(quizHour) >= 10 ? quizHour : "0" + quizHour;
        var quizMinutes = timeDuration % 60 === 0 ? "00" : timeDuration % 60;
        var quizSecond = "00";
        const quizTime = quizHour + ":" + quizMinutes + ":" + quizSecond;

        const remainingMinutes =
            data.minutes < 10 ? "0" + data.minutes : data.minutes; // return minutes
        const remainingSeconds =
            data.seconds < 10 ? "0" + data.seconds : data.seconds;

        const remainTime =
            "0" + data.hours + ":" + remainingMinutes + ":" + remainingSeconds;
        var start = moment.duration(quizTime, "HH:mm:ss");
        var end = moment.duration(remainTime, "HH:mm:ss");
        var diff = start.subtract(end);

        const hour = diff.hours(); // return hours
        const minutes = diff.minutes() < 10 ? "0" + diff.minutes() : diff.minutes(); // return minutes
        const seconds = diff.seconds() < 10 ? "0" + diff.seconds() : diff.seconds();
        const usedTime = "0" + hour + ":" + minutes + ":" + seconds;

        setQuizTotalTime(quizTime);
        setRemainingTime(remainTime);
        setTakenTime(usedTime);

        if (remainTime === "00:00:01") {
            alert.info("Time up, your exam is submitting forcefully!!!", {
                onOpen: () => {
                    if (theoriesAnswered.length > 0) {
                        dispatch(
                            submitExamResult(
                                userId,
                                examId,
                                theoriesAnswered,
                                assessmentId,
                                subjectIds,
                                year,
                                totalQuestions,
                                quizTotalTime,
                                remainTime,
                                takenTime,
                                savedSubjectId,
                                examType
                            )
                        );
                    } else {
                        history.push(`/results`);
                    }
                },
            });
        }
    };

    // if (remainingTime === "00:00:01") {
    //   alert.info("Time up, your exam is submitting forcefully!!!", {
    //     onOpen: () => {
    //       dispatch(
    //         submitExamResult(
    //           userId,
    //           examId,
    //           theoriesAnswered,
    //           assessmentId,
    //           subjectIds,
    //           year,
    //           totalQuestions,
    //           quizTotalTime,
    //           remainingTime,
    //           takenTime,
    //           savedSubjectId,
    //           examType
    //         )
    //       );
    //       //history.push(`/results`);
    //     },
    //   });
    // }

    const handleSubmitAnswer = (e) => {
        e.preventDefault();
        if (theoriesAnswered.length > 0) {
            if (
                window.confirm(
                    "Do you really want to submit your answer. We recommend you to review your answer before submitting it."
                )
            ) {
                // console.log("answered ", answered);
                // return;
                dispatch(
                    submitExamResult(
                        userId,
                        examId,
                        theoriesAnswered,
                        assessmentId,
                        subjectIds,
                        year,
                        totalQuestions,
                        quizTotalTime,
                        remainingTime,
                        takenTime,
                        savedSubjectId,
                        examType
                    )
                );
            }
        } else {
            //alert.warning("You have not answered any questions")
            if (
                window.confirm(
                    "You have not answered any questions, your test will be cancelled. do you really want to cancel?"
                )
            ) {
                alert.info("Test has been cancelled.");
                history.push(`/dashboard`);
            }
        }
        return;
    };

    const { rLoading, isSubmitted, result } = useSelector(
        (state) => state.results
    );

    useEffect(() => {
        if (isSubmitted === true && isSubmitted != undefined) {
            /*if (examData.examType === 'theory' || examData.examType === 'both') {
                          alert.info("Your result is under consideration, you'll receive a notification on decleration.");
                      } else {
                          alert.success('Result successfully submitted.');
                      }*/
            alert.success("Result successfully submitted.");
            //history.push(`/practice-results/${result.quizId}`);
            history.push(`/theories-grade/${result.quizId}`);
            dispatch({
                type: SUBMIT_RESULT_RESET,
            });
        }
    }, [dispatch, rLoading, isSubmitted, alert]);

    // function createMarkup() {
    //   return {__html: 'First &middot; Second'};
    // }
    // console.log("filtered", theoriesAnswered?.map((item) => item.theory == questions[currentSubject].theories[currentQuestion]._id) ? item : "")

    // Show loader while user data is loading
    if (loading || !user) {
        return <Loader />;
    }

    return (
        <Fragment>
            <section className="auth-dash-sec fullHt">
                <div className="left-navigations">
                    <div className="user-exam">
                        <div className="user-pros-exam" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '90px', width: '90px', margin: '0 auto' }}>
                            <img
                                src={userAvatarUrl()}
                                alt="user"
                                style={{ borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', background: '#f3f3f3', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </div>
                        <h4>
                            <b>Name</b>: {userFirst} {userLast}
                        </h4>
                        <div className="user-meta-block">
                            <div className="meta-row">
                                {assessmentLabel && (
                                    <span className="assessment-label">
                                        <i className="fas fa-book-open" /> {assessmentLabel}
                                    </span>
                                )}
                                <span className="calculator-link" onClick={() => setShowCalculator(true)}>
                                    Calculator
                                </span>
                            </div>
                            {(year || examTypeLabel) && (
                                <div className="meta-row meta-row-secondary">
                                    {year && (
                                        <span className="year-label">
                                            <i className="fas fa-calendar-alt" />
                                            {year}
                                        </span>
                                    )}
                                    {examTypeLabel && (
                                        <span className="exam-type-label">{examTypeLabel}</span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <Modal title="Calculator" onClose={() => setShowCalculator(false)} show={showCalculator}>
                        <Calculator />
                    </Modal>
                    <div className="bot-examers">
                        {/*<h2>Subjects</h2>*/}
                        <div className="subject-tab">
                            <ul className="nav nav-tabs" role="tablist">
                                {questions.map((subItem, i) => {
                                    if (subItem.theories.length > 0) {
                                        return (
                                            <Fragment key={i}>
                                                <li
                                                    role="presentation"
                                                    className={currentSubject === i ? "active" : ""}
                                                >
                                                    <a
                                                        href="#"
                                                        // href={`#${subItem.subject.slug}`}
                                                        // aria-controls={`${subItem.subject.slug}`}
                                                        // role="tab"
                                                        // data-toggle="tab"
                                                        data-id={i}
                                                        onClick={handleSubjectType}
                                                    >
                                                        {subItem.subject.title}
                                                    </a>
                                                </li>
                                            </Fragment>
                                        );
                                    }
                                })}
                            </ul>

                            {/*
              <div className="tab-content">
                {questions[currentSubject] !== undefined &&
                  questions[currentSubject].subject !== undefined && (
                    <div
                      role="tabpanel"
                      className="tab-pane active"
                      id={`${questions[currentSubject].subject.slug}`}
                    >
                      <div className="questions-opt">
                        <h5>Topic</h5>

                        <div className="boxes">
                          <input type="checkbox" id="box-1" />
                          <label for="box-1">Plant</label>

                          <input type="checkbox" id="box-2" checked />
                          <label for="box-2">Cell Biology</label>

                          <input type="checkbox" id="box-3" />
                          <label for="box-3">Other</label>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
                  */}
                        </div>

                        <div className="number-lister">
                            {activeSubject?.theories &&
                                activeSubject.theories.length > 0 &&
                                [...Array(activeSubject.theories.length)].map(
                                    (e, i) => {
                                        let className = "";
                                        if (
                                            markForReviewed.indexOf(
                                                activeSubject.theories[i]._id
                                            ) > -1
                                        ) {
                                            className = "markForReviewQuestion";
                                        } else if (
                                            theoriesAnswered.find(
                                                (obj) =>
                                                    obj.theory ==
                                                    activeSubject.theories[i]._id
                                            )
                                        ) {
                                            theoriesAnswered
                                                .filter(
                                                    (tItem) =>
                                                        tItem.theory ===
                                                        activeSubject.theories[currentQuestion]
                                                            ._id
                                                )
                                                .map((filteredAnswer) => {
                                                    // filteredAnswer.answer
                                                    if (filteredAnswer.answer !== "") {
                                                        className = "markForAnsweredQuestion";
                                                    } else {
                                                        className = "isActiveQuestion";
                                                    }
                                                });
                                        } else if (currentQuestion === i) {
                                            className = "isActiveQuestion";
                                        }
                                        return (
                                            <Fragment key={i}>
                                                <a
                                                    className={className}
                                                    href="#"
                                                    data-id={i}
                                                    onClick={handleFilterQuestion}
                                                >
                                                    {i + 1}
                                                </a>{" "}
                                            </Fragment>
                                        );
                                    }
                                )}
                        </div>
                    </div>
                </div>

                <div className="right-auth-landing edit-pros">
                    <div className="main-view-content">
                        {assessmentType !== "study" && (
                            <div className="all-ourt-style timer w-80-cust legends-reviews clearfix">
                                <div className="pull-left legend-label">
                                    <div>Time Remaining</div> &nbsp;&nbsp;
                                    <div>
                                        <Countdown
                                            date={totalTime}
                                            //zeroPadTime={2}
                                            daysInHours={true}
                                            controlled={false}
                                            onTick={handleRemainigTime}
                                        //renderer={renderer}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <Fragment>
                            <div className="all-ourt-style w-80-cust legends-reviews clearfix">
                                <div className="pull-left legend-label">
                                    <p>
                                        <span style={{ background: "white" }} /> Un Answered
                                    </p>
                                    <p>
                                        <span style={{ background: "green" }} /> Answered
                                    </p>
                                    <p>
                                        <span style={{ background: "red" }} /> Marked for Review
                                    </p>
                                </div>
                                {activeSubject?.theories &&
                                    activeSubject.theories.length > 0 && (
                                        <div className="pull-right">
                                            <div
                                                className="boxes"
                                                style={{ display: "inline-block" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={`review-mark-${activeTheoryId || ""}`}
                                                    id={`box-${activeTheoryId || ""}`}
                                                    value={activeTheoryId || ""}
                                                    onChange={handleMarkForReview}
                                                    checked={
                                                        activeTheoryId
                                                            ? markForReviewed.indexOf(activeTheoryId) > -1
                                                            : false
                                                    }
                                                />
                                                <label
                                                    htmlFor={`box-${activeTheoryId || ""}`}
                                                >
                                                    Mark for Review
                                                </label>
                                            </div>
                                            {/*:<span>(1) Question</span>*/}
                                        </div>
                                    )}
                            </div>

                            {activeTheory && (
                                <Fragment>
                                    <div className="all-ourt-style w-80-cust work-info exam-set">
                                        <div className="all-heads clearfix">
                                            <h2 className="question-title">
                                                Question {parseInt(currentQuestion) + 1}.
                                            </h2>
                                        </div>

                                        {shouldShowSubtitle && activeTheory?.title && (
                                            <div className="question-subtitle">
                                                {parse(activeTheory.title)}
                                            </div>
                                        )}

                                        {shouldShowQuestionText && activeTheory?.question && (
                                            <div className="question-text">
                                                {parse(activeTheory.question)}
                                            </div>
                                        )}

                                        {activeTheory?.logo && (
                                            <Fragment>
                                                <img
                                                    src={questionImageUrl(activeTheory.logo)}
                                                    alt={activeTheory.logo}
                                                    style={{ height: "200px" }}
                                                />
                                            </Fragment>
                                        )}

                                        <div className="exam-main-style">
                                            <div className="answer-selection">
                                                {activeSubject?.theories &&
                                                    activeSubject.theories.length > 0 ? (
                                                    <Fragment>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="answer">
                                                                        Answer <span className="impot-star">*</span>
                                                                    </label>
                                                                    <textarea
                                                                        name="answer"
                                                                        className="form-control"
                                                                        data-theoriesid={activeTheoryId || ""}
                                                                        id={`option-${activeTheoryId || ""}`}
                                                                        placeholder="Enter Answer"
                                                                        required
                                                                        onChange={handleTheoriesAnswer}
                                                                        value={currentTheoryAnswerValue}
                                                                    />
                                                                    {/*
                                                                    <Editor
                                                                        id={`option-${questions[currentSubject].theories[currentQuestion]._id}`}
                                                                        apiKey="nag9rfyktzweza49mzb77l9378ilslwdo58xufcns615clff"

                                                                        init={{
                                                                            height: 200,
                                                                            menubar: false,
                                                                            external_plugins: {
                                                                                tiny_mce_wiris:
                                                                                    "https://www.wiris.net/demo/plugins/tiny_mce/plugin.js",
                                                                            },
                                                                            plugins: [
                                                                                "advlist autolink lists link image imagetools tiny_mce_wiris charmap print preview anchor",
                                                                                "searchreplace visualblocks code fullscreen",
                                                                                "insertdatetime media table paste code help wordcount",
                                                                            ],
                                                                            external_plugins: {
                                                                                tiny_mce_wiris:
                                                                                    'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
                                                                            },
                                                                            toolbar:
                                                                                "tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry | " +
                                                                                "undo redo | formatselect " +
                                                                                "bold italic backcolor | alignleft aligncenter alignright alignjustify | MathType" +
                                                                                "bullist numlist outdent indent | " +
                                                                                "removeformat | help",
                                                                            content_style:
                                                                                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                                        }}
                                                                        value={theoriesAnswered
                                                                            .filter(
                                                                                (tItem) =>
                                                                                    tItem.theory ==
                                                                                    questions[currentSubject].theories[
                                                                                        currentQuestion
                                                                                    ]._id
                                                                            )
                                                                            .map(
                                                                                (filteredAnswer) =>
                                                                                    filteredAnswer.answer
                                                                            ).join('')}

                                                                        onEditorChange={(value) => {

                                                                            const id = questions[currentSubject].theories[
                                                                                currentQuestion
                                                                            ]._id
                                                                            handleTheoriesEditorAnswer(id, value)
                                                                        }
                                                                        }
                                                                    />
                                                                    */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            )}
                        </Fragment>

                        <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                            {assessmentType === "study" && (
                                <div className="pull-left">
                                    <button
                                        type="button"
                                        className="btn view-ans-btn"
                                        onClick={handleViewAnswer}
                                    >
                                        {!showResults ? "View Answer" : "Hide Answer"}
                                    </button>
                                    {rightAnswer !== undefined && showResults && (
                                        <>
                                            <div className="correct-answer">Correct Answer :- {parse(rightAnswer)}</div>
                                            {/* <p className="correct-answer">Description :- {description}</p> */}
                                            <p className="correct-answer">Detailed Answer :- {parse(detailedAns)}</p>
                                        </>
                                    )}
                                </div>
                            )}
                            <div className="pull-right">
                                {currentQuestion > 0 && (
                                    <button
                                        type="submit"
                                        className="btn nxt-prv"
                                        onClick={handlePreviousQuestionClick}
                                    >
                                        <i className="fas fa-angle-left" /> Prev
                                    </button>
                                )}

                                {currentQuestion < numberOfQuestions - 1 && (
                                    <button
                                        type="submit"
                                        className="btn nxt-prv"
                                        //disabled={!answer}
                                        onClick={handleNextQuestionClick}
                                    >
                                        Next <i className="fas fa-angle-right" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {assessmentType !== "study" && (
                            <div className="all-ourt-style w-80-cust next-prev-cust clearfix">
                                <div className="pull-left" />
                                <div className="pull-right">
                                    <button
                                        type="submit"
                                        className="btn submit-ans-btn"
                                        // disabled={true}
                                        onClick={handleSubmitAnswer}
                                    >
                                        Submit Test
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

// Random component
const Completionist = () => <span>Time Up!</span>;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <Completionist />;
    } else {
        // Render a countdown
        return (
            <span>
                {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
            </span>
        );
    }
};

export default TheoriesQuestions;
